<script lang="ts">
  import { getColorHexCodeFromCouchUuId } from '#app/lib/images/images'
  import { viewportIsSmallerThan } from '#app/lib/screen'
  import { isOpenedOutside } from '#app/lib/utils'
  import type { ClickEvent } from '#app/types/declarations/svelte'
  import type { OnSelectShelf } from '#inventory/types/inventory_browser'
  import type { SerializedShelf } from '#shelves/lib/shelves'

  const {
    shelf,
    onSelectShelf,
  }: {
    shelf: SerializedShelf
    onSelectShelf?: OnSelectShelf
  } = $props()

  const name = $derived(shelf.name)
  const _id = $derived(shelf._id)

  const colorHexCode = $derived(shelf.color || `#${getColorHexCodeFromCouchUuId(_id)}`)

  function onShelfDotClick (e: ClickEvent) {
    if (isOpenedOutside(e)) return
    onSelectShelf(shelf)
    e.preventDefault()
    e.stopPropagation()
  }
</script>
<li>
  {#if viewportIsSmallerThan(600)}
    <div
      class="shelf-dot"
      title={name}
      style:background-color={colorHexCode}
    ></div>
  {:else}
    <a
      href="/shelves/{_id}"
      onclick={onShelfDotClick}
      title={name}
      aria-label={name}
    >
      <div
        class="shelf-dot"
        style:background-color={colorHexCode}
      ></div>
    </a>
  {/if}
</li>
<style lang="scss">
  @import "general/scss/utils";

  .shelf-dot{
    @include radius;
    width: 1em;
    height: 1em;
    margin: 0.3em;
  }

  /* Large screens */
  @media screen and (width >= $smaller-screen){
    .shelf-dot{
      margin: 0.2em;
    }
  }
</style>
